import { AppText, AppIcon } from "@toothfairy/shared-ui";
import AppTheme from "@toothfairy/shared-ui/AppTheme";
import AppAssets from "@toothfairy/shared-ui/AppAssets";
import React, { useEffect, useState } from "react";
import { View, TouchableOpacity } from "react-native";
import QaHiringResourcesInstancesLeaf from "./QaHiringResourcesInstancesLeaf";

const QaHiringResourcesLeaf = ({
  title,
  iconTitle,
  resources,
  onTick = () => {},
  excludedResources = [],
  isRecap = false,
}) => {
  const { currentTheme } = AppTheme.useTheme();
  const [isEmpty, setIsEmpty] = useState(false);
  const [isExpanded, setIsExpanded] = useState(!isRecap);

  useEffect(() => {
    let count = 0;
    for (let i = 0; i < resources?.length; i++) {
      if (excludedResources.includes(resources[i].id)) count++;
    }
    if (count === resources?.length) setIsEmpty(true);
    else setIsEmpty(false);
  }, [excludedResources, resources]);

  const selectedCount =
    resources?.filter((r) => !excludedResources.includes(r.id)).length || 0;
  const totalCount = resources?.length || 0;

  const getTitleIcon = () => {
    switch (title) {
      case "Data sources":
        return "💾";
      case "Execution hooks":
        return "🔧";
      case "Tools":
        return "⚙️";
      case "Prompts":
        return "💬";
      default:
        return "📦";
    }
  };

  return (
    <View>
      <TouchableOpacity
        onPress={() => setIsExpanded(!isExpanded)}
        style={{
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          paddingVertical: 8,
          paddingHorizontal: 10,
          backgroundColor: isRecap
            ? `${currentTheme?.theme?.softBackgroundColor}`
            : `${currentTheme?.theme?.backgroundColor}`,
          borderRadius: 6,
          marginBottom: 10,
        }}
      >
        <View style={{ flexDirection: "row", alignItems: "center" }}>
          <AppText
            preventTranslation
            style={{
              fontSize: 14,
              fontWeight: "600",
              marginRight: 4,
            }}
            color={currentTheme?.theme?.orange}
          >
            {getTitleIcon()}
          </AppText>
          <AppText
            preventTranslation
            style={{
              fontSize: 14,
              fontWeight: "600",
            }}
            color={currentTheme?.theme?.orange}
          >
            {title}
          </AppText>

          {!isRecap && (
            <View
              style={{
                marginLeft: 10,
                paddingHorizontal: 8,
                paddingVertical: 3,
                backgroundColor: `${currentTheme?.theme?.orange}20`,
                borderRadius: 10,
              }}
            >
              <AppText
                preventTranslation
                style={{
                  fontSize: 10,
                  fontWeight: "600",
                }}
                color={currentTheme?.theme?.orange}
              >
                {`${selectedCount}/${totalCount} selected`}
              </AppText>
            </View>
          )}

          {isRecap && selectedCount > 0 && (
            <View
              style={{
                marginLeft: 10,
                paddingHorizontal: 8,
                paddingVertical: 3,
                backgroundColor: `${currentTheme?.theme?.primary}20`,
                borderRadius: 10,
              }}
            >
              <AppText
                preventTranslation
                style={{
                  fontSize: 10,
                  fontWeight: "600",
                  marginLeft: 2,
                }}
                color={currentTheme?.theme?.white}
              >
                {`${selectedCount} to import`}
              </AppText>
            </View>
          )}
        </View>

        {!isRecap && (
          <AppIcon
            icon={
              isExpanded
                ? AppAssets?.icons?.chevron_up
                : AppAssets?.icons?.chevron_down
            }
            size={14}
            color={currentTheme?.theme?.secondary_font_color}
          />
        )}
      </TouchableOpacity>

      {isExpanded && isEmpty && isRecap ? (
        <View
          style={{
            marginLeft: 10,
            padding: 12,
            backgroundColor: `${currentTheme?.theme?.orange}10`,
            borderRadius: 6,
            borderLeftWidth: 3,
            borderLeftColor: currentTheme?.theme?.orange,
          }}
        >
          <AppText
            preventTranslation
            style={{
              fontSize: 12,
            }}
            color={currentTheme?.theme?.secondary_font_color}
          >
            ⚠️ No resources will be imported
          </AppText>
        </View>
      ) : (
        isExpanded && (
          <View>
            {resources?.map((u) => {
              if ((isRecap && !excludedResources?.includes(u?.id)) || !isRecap)
                return (
                  <QaHiringResourcesInstancesLeaf
                    key={u?.id}
                    u={u}
                    onTick={(_v) => onTick(u, _v)}
                    isTicked={excludedResources?.includes(u?.id) ? false : true}
                    isRecap={isRecap}
                  />
                );
              else {
                return null;
              }
            })}
          </View>
        )
      )}
    </View>
  );
};

export default QaHiringResourcesLeaf;
